var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperty1Jcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 17.5281C23 19.4108 21.467 20.9438 19.5844 20.9438H1V7.41565C1 5.53301 2.53301 4 4.41565 4H23V17.5281Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9492 14.0585H18.3612C18.4015 14.0585 18.4957 14.0451 18.536 14.0451C18.805 13.9913 19.0336 13.7492 19.0336 13.4131C19.0336 13.0903 18.805 12.8483 18.536 12.781C18.4957 12.7676 18.415 12.7676 18.3612 12.7676H16.9492V14.0585Z",
    fill: "url(#paint0_linear_9402_16753)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1992 5.14258C16.8544 5.14258 15.7517 6.23182 15.7517 7.59001V10.1316H19.2077C19.2884 10.1316 19.3825 10.1316 19.4498 10.145C20.2297 10.1854 20.808 10.5888 20.808 11.2881C20.808 11.8394 20.418 12.3101 19.6918 12.4042V12.4311C20.4852 12.4849 21.0904 12.9286 21.0904 13.6145C21.0904 14.3541 20.418 14.8382 19.5305 14.8382H15.7383V19.8137H19.3287C20.6735 19.8137 21.7762 18.7245 21.7762 17.3663V5.14258H18.1992Z",
    fill: "url(#paint1_linear_9402_16753)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8588 11.4496C18.8588 11.1269 18.6301 10.9117 18.3612 10.8714C18.3343 10.8714 18.2671 10.8579 18.2267 10.8579H16.9492V12.0413H18.2267C18.2671 12.0413 18.3478 12.0413 18.3612 12.0278C18.6301 11.9875 18.8588 11.7723 18.8588 11.4496Z",
    fill: "url(#paint2_linear_9402_16753)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67182 5.14258C3.32707 5.14258 2.22438 6.23182 2.22438 7.59001V13.6279C2.9102 13.9641 3.62292 14.1793 4.33563 14.1793C5.18282 14.1793 5.64003 13.6682 5.64003 12.969V10.1181H7.73783V12.9555C7.73783 14.0582 7.05201 14.9592 4.72561 14.9592C3.31363 14.9592 2.21094 14.6499 2.21094 14.6499V19.8003H5.8014C7.14614 19.8003 8.24883 18.711 8.24883 17.3528V5.14258H4.67182Z",
    fill: "url(#paint3_linear_9402_16753)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4347 5.14258C10.09 5.14258 8.9873 6.23182 8.9873 7.59001V10.7905C9.60589 10.266 10.6817 9.92986 12.4164 10.0105C13.3443 10.0509 14.3394 10.3064 14.3394 10.3064V11.3418C13.8418 11.0863 13.2501 10.8577 12.4836 10.8039C11.1658 10.7098 10.3724 11.3553 10.3724 12.4849C10.3724 13.6279 11.1658 14.2734 12.4836 14.1658C13.2501 14.112 13.8418 13.87 14.3394 13.6279V14.6634C14.3394 14.6634 13.3577 14.9189 12.4164 14.9592C10.6817 15.0399 9.60589 14.7037 8.9873 14.1793V19.8272H12.5778C13.9225 19.8272 15.0252 18.7379 15.0252 17.3797V5.14258H11.4347Z",
    fill: "url(#paint4_linear_9402_16753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9402_16753",
    x1: 15.7502,
    y1: 13.4147,
    x2: 21.7931,
    y2: 13.4147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9402_16753",
    x1: 15.7493,
    y1: 12.4723,
    x2: 21.7927,
    y2: 12.4723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9402_16753",
    x1: 15.75,
    y1: 11.4479,
    x2: 21.7932,
    y2: 11.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9402_16753",
    x1: 2.22154,
    y1: 12.4723,
    x2: 8.35801,
    y2: 12.4723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9402_16753",
    x1: 8.95254,
    y1: 12.4723,
    x2: 14.9125,
    y2: 12.4723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Jcb);
export default __webpack_public_path__ + "static/media/Property 1=jcb.0afad3fdbddc8fe08cce743ed2c4e967.svg";
export { ForwardRef as ReactComponent };